export default {"src":"/_next/static/media/twitter.ee9a8ce5.svg","height":21,"width":24};